export const BRANCH_ID = 1;
export const API_URL = import.meta.env.VITE_API_URL;
export const MASTER_NAME = import.meta.env.VITE_MASTER_NAME;
export const IS_MUSE_GN = MASTER_NAME === 'muse-gangnam';
export const IS_HONGKONG = MASTER_NAME === 'skinbeam-hongkong';

// 병원 관련 정보 (문서에서 사용중)
export const INFO_INSTITUTION = '뮤즈 의원';
export const INFO_PHONE = '1544-2994';
export const INFO_FAX = '02-555-2994';
export const INFO_ADDRESS = '서울 강남구 강남대로 452 대연빌딩 2-5층';
